export default __webpack_public_path__ + "static/media/email-dark.75fd9aac.svg";